import React, { useEffect, useState } from 'react';
import SettingToggle from '../SettingToggle/SettingToggle';
import Honeybadger from 'honeybadger-js';
import { usePagesQuery, useUpdatePageMutation, Wws_Page } from '../../../generated/graphql';

interface RegistryVisibilityProps {
  onError: () => void;
}

const RegistryVisibility = ({ onError }: RegistryVisibilityProps) => {
  const [registryPage, setRegistryPage] = useState<Wws_Page | undefined>();
  const [updatePage] = useUpdatePageMutation();
  const { data: pagesData } = usePagesQuery();

  useEffect(() => {
    if (pagesData?.pages) {
      const registryPage = pagesData.pages.find(page => page.type === 'RegistryPage');
      if (registryPage) {
        setRegistryPage(registryPage as Wws_Page);
      }
    }
  }, [pagesData]);

  const isRegistryVisible = registryPage?.show ?? true;

  const onChange = async (checked: boolean): Promise<void> => {
    try {
      if (!registryPage) {
        return;
      }

      await updatePage({
        variables: {
          id: registryPage.id,
          attributes: {
            show: checked,
          },
        },
      });
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error updating registry visibility',
        context: {
          error,
        },
      });
      onError();
    }
  };

  return (
    <SettingToggle
      title="Registry visibility"
      subtitle={
        <span>
          Show your registry page. <a href="/registry">View registry</a>
        </span>
      }
      checked={isRegistryVisible}
      onChange={onChange}
      dataTestId="registry_visibility_toggle"
    />
  );
};

export default RegistryVisibility;
